<template>
  <esg-base-dashboard-card :title="title"
                           id="esg-partner-corp-monitoring-grid">
    <div class="table-wrap">
      <esg-table-without-meta :items="getItem"
                              :fields="fields"
                              size="sm">
        <template #cell(index)="data">
          <td class="text-center">{{ data.value }}</td>
        </template>
        <template #cell(desc)="data">
          <td class="text-left">{{ data.value }}</td>
        </template>
        <template #cell(valueChainRole)="data">
          <td class="text-left ">{{ data.item.valueChainRole }}</td>
        </template>
        <template #cell(fileUrl)="data">
          <td class="text-center">
            <img v-if="data.item.file !== ''"
                 class="fit-picture"
                 src="@/components/esg/images/excel.png"
                 alt="Grapefruit slice atop a pile of other slices"
                 style="height:1.5em;"/>
          </td>
        </template>
        <template #cell(emissionAmt)="data">
          <td class="text-center ">{{ (data.item.emissionAmt).toLocaleString() }}</td>
        </template>
        <template #cell(fluctuation)="data">
          <td class="text-center ">
          <span :style="{ color: data.item.fluctuation > 0 ? '#FF241F':'#2C2CF2' }">{{
              data.item.fluctuation > 0 ? '▲' : '▼'
            }}</span>
            {{ Math.abs(data.item.fluctuation).toLocaleString() }}
          </td>
        </template>
        <template #cell(assessmentElement)="data">
          <td class="text-left">{{ data.item.assessmentElement }}</td>
        </template>
        <template #cell(assessmentElementDesc)="data">
          <td class="text-center ">{{ data.item.assessmentElementDesc }}</td>
        </template>
      </esg-table-without-meta>
    </div>
  </esg-base-dashboard-card>
</template>
<script>
import EsgBaseDashboardCard from "@/components/esg/base/EsgBaseDashboardCard.vue";
import EsgTableWithoutMeta from "@/components/esg/base/EsgTableWithoutMeta.vue";

export default {
  components: { EsgTableWithoutMeta, EsgBaseDashboardCard },
  props: ['gridId'],
  data() {
    return {
      loading: false,
      items: [
        [
          {
            partnerTier: "Tier 1",
            partnerType: "전체 협력사",
            amtOfPartnerCorp: "2,632",
            purchasingRate: 100,
            desc: '직접 거래 협력사(전년도 및 당해년도 발주 협력사)'
          },
          {
            partnerTier: "Tier 1",
            partnerType: "핵심 협력사",
            amtOfPartnerCorp: "249",
            purchasingRate: 62,
            desc: '전략적 중요도와 ESG 리스크 노출도가 모두 높은 협력사'
          },
          {
            partnerTier: "Tier 2",
            partnerType: "전체 협력사",
            amtOfPartnerCorp: "240",
            purchasingRate: 100,
            desc: '전일정 구매금액 이상 거래를 진행한 1차 협력사의 중간 도급업체'
          },
          {
            partnerTier: "Tier 2",
            partnerType: "핵심 협력사",
            amtOfPartnerCorp: "60",
            purchasingRate: 25,
            desc: '전략적 중요도와 ESG 리스크 노출도가 모두 높은 협력사'
          }
        ],
        [
          {
            assessmentElement: "Environment",
            assessmentElementDesc: "환경",
            leader: 12,
            average: 104,
            laggard: 133,
            fileUrl: 'test'
          },
          {
            assessmentElement: "Social",
            assessmentElementDesc: "안전",
            leader: 12,
            average: 100,
            laggard: 137,
            fileUrl: 'test'
          },
          {
            assessmentElement: "Social",
            assessmentElementDesc: "사회",
            leader: 10,
            average: 139,
            laggard: 100,
            fileUrl: 'test'
          },
          {
            assessmentElement: "Social",
            assessmentElementDesc: "윤리",
            leader: 8,
            average: 134,
            laggard: 107,
            fileUrl: 'test'
          },
          {
            assessmentElement: "Gorvernance",
            assessmentElementDesc: "경제",
            leader: 12,
            average: 134,
            laggard: 103,
            fileUrl: 'test'
          },
          {
            assessmentElement: "Gorvernance",
            assessmentElementDesc: "경영시스템",
            leader: 5,
            average: 130,
            laggard: 114,
            fileUrl: 'test'
          }
        ],
        [
          {
            index: 1,
            partnerCorpName: "EY 기계",
            valueChainRole: '원료 획득',
            emissionAmt: 34938,
            emissionAmtOfLastYear: 33927
          },
          {
            index: 2,
            partnerCorpName: "EY 운송",
            valueChainRole: '다운스트림 운송',
            emissionAmt: 34845,
            emissionAmtOfLastYear: 33222
          },
          {
            index: 3,
            partnerCorpName: "PW 운송",
            valueChainRole: '다운스트림 운송',
            emissionAmt: 29784,
            emissionAmtOfLastYear: 14214
          },
          {
            index: 4,
            partnerCorpName: "WC 정공",
            valueChainRole: '업스트림 운송',
            emissionAmt: 27331,
            emissionAmtOfLastYear: 41421
          },
          {
            index: 5,
            partnerCorpName: "WC 국제운송",
            valueChainRole: '다운스트림 운송',
            emissionAmt: 20916,
            emissionAmtOfLastYear: 15484
          }
        ]
      ],
    }
  },
  created() {
  },
  computed: {
    title() {
      if (this.gridId === 0) {
        return '현황';
      } else if (this.gridId === 1) {
        return '평가';
      } else {
        return '온실가스 배출량 상위 5사';
      }
    },
    getItem() {
      if (this.gridId === 2) {
        this.items[this.gridId].forEach(item => item.fluctuation = item.emissionAmt - item.emissionAmtOfLastYear)
      }
      return this.items[this.gridId];
    },
    fields() {
      let fieldSet = [];
      switch (this.gridId) {
        case 0:
          fieldSet = [
            {
              name: "partnerTier",
              label: "구분",
              list: true,
            },
            {
              name: "partnerType",
              label: "타입",
              list: true,
            },
            {
              name: "amtOfPartnerCorp",
              label: "협력사 수",
              list: true,
            },
            {
              name: "purchasingRate",
              label: "구매 비중(%)",
              list: true,
            },
            {
              name: "desc",
              label: "설명",
              list: true,
            }
          ]
          break;
        case 1:
          fieldSet = [
            {
              name: "assessmentElement",
              label: "평가 요소",
              list: true,
            },
            {
              name: "assessmentElementDesc",
              label: "평가항목",
              list: true,
            },
            {
              name: "leader",
              label: "Leader",
              list: true,
            },
            {
              name: "average",
              label: "Average",
              list: true,
            },
            {
              name: "laggard",
              label: "Laggard",
              list: true,
            },
            {
              name: "fileUrl",
              label: "평가파일",
              list: true,
            }
          ]
          break;
        case 2:
          fieldSet = [
            {
              name: "index",
              label: "랭크",
              list: true,
            },
            {
              name: "partnerCorpName",
              label: "협력사명",
              list: true,
            },
            {
              name: "valueChainRole",
              label: "벨류체인 역할",
              list: true,
            },
            {
              name: "emissionAmt",
              label: "배출량(tCO2e)",
              list: true,
              sortable: true
            },
            {
              name: "fluctuation",
              label: "전년대비 증감",
              list: true,
              sortable: true
            }
          ]
          break;
      }
      return fieldSet;
    }
  },
  methods: {},
}
</script>

<style scoped>
.table-wrap {
  height: 100%;
  overflow-x: auto;
  display: flex;
  align-items: center;
}

.table-wrap > div {
  flex-grow: 1;
}
</style>